module.exports = __webpack_public_path__ + "static/stay-on-track-4d79d29f2332e4ebb2ea1056c1542efe.svg";